module.exports = __webpack_public_path__ + "media/images/proof_links/colored/vimeo-1d75aee12ec7fe210f93782ebfe67d6f.svg";